import React, { useEffect, useState } from "react";
import "../Styles/ReceiptScreen.css";
import { useParams } from "react-router-dom";
import db from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { QRCode } from "react-qrcode-logo";

function ReceiptScreen() {
  const { document_id } = useParams();

  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const docRef = doc(db, "receipts", document_id);
        const response = await getDoc(docRef);
        if (response.exists()) {
          setReceipt(response.data());
        } else {
          console.log("No such receipt!");
        }
      } catch (error) {
        console.error("Error fetching receipt:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReceipt();
  }, [document_id]);

  const formatAmount = (value) => {
    if (!value && value !== 0) return "0.00";
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toFixed(2);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "—";
    // Check if it's a Firestore timestamp
    let date;
    if (timestamp.toDate) {
      date = timestamp.toDate();
    } else if (typeof timestamp === 'string') {
      date = new Date(timestamp);
    } else if (timestamp.seconds) {
      date = new Date(timestamp.seconds * 1000);
    } else {
      date = new Date(timestamp);
    }

    // Check if date is valid
    if (isNaN(date.getTime())) return "—";

    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <div className="loading-text">Loading...</div>
      </div>
    );
  }

  if (!receipt) {
    return (
      <div className="receipt-screen">
        <div className="pdf-receipt-wrapper" style={{ padding: '40px', textAlign: 'center' }}>
          <h1 className="pdf-text-bold">Receipt Not Found</h1>
          <p>The requested receipt could not be found.</p>
        </div>
      </div>
    );
  }

  const amount = receipt.total ? receipt.total : 0;
  const note = receipt.note ? receipt.note.trim() : "";
  const upiQrData = receipt.link || `upi://pay?pa=${receipt.upi_id}&pn=${receipt.username}&tn=${note}&cu=INR&am=${amount}`;

  return (
    <div className="receipt-screen" style={{ flexDirection: 'column', alignItems: 'center' }}>
      <div className="pdf-receipt-wrapper">
        <div className="pdf-text-bold" style={{ fontSize: '14px', letterSpacing: '1.2px' }}>RECEIPT</div>
        <div style={{ height: '6px' }} />
        <div className="pdf-text-bold" style={{ fontSize: '16px' }}>{receipt.username}</div>
        <div style={{ fontSize: '10px' }}>{receipt.upi_id || "—"}</div>
        <div style={{ height: '4px' }} />
        <div style={{ fontSize: '10px' }}>{formatDate(receipt.timestamp)}</div>
        <div style={{ height: '10px' }} />
        <hr className="pdf-divider" />
        <div className="pdf-text-bold" style={{ fontSize: '11px', letterSpacing: '1px' }}>ITEMS</div>
        <div style={{ height: '6px' }} />

        {receipt.items && receipt.items.length > 0 ? (
          receipt.items.map((item, index) => (
            <div key={index} style={{ padding: '3px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, fontSize: '10px' }}>{item.name || "Item"}</div>
                <div style={{ fontSize: '9px', marginLeft: '8px' }}>x{(item.qty || 1).toFixed(2)}</div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ fontSize: '9px' }}>@ {formatAmount(item.unit_price)}</div>
                <div className="pdf-text-bold" style={{ fontSize: '10px' }}>{formatAmount(item.line_total)}</div>
              </div>
            </div>
          ))
        ) : (
          <div style={{ padding: '3px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1, fontSize: '10px' }}>{note || "Payment"}</div>
              <div style={{ fontSize: '9px', marginLeft: '8px' }}>x1.00</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ fontSize: '9px' }}>@ {formatAmount(amount)}</div>
              <div className="pdf-text-bold" style={{ fontSize: '10px' }}>{formatAmount(amount)}</div>
            </div>
          </div>
        )}

        <hr className="pdf-divider" />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="pdf-text-bold" style={{ fontSize: '12px' }}>Total</div>
          <div className="pdf-text-bold" style={{ fontSize: '14px' }}>{formatAmount(amount)}</div>
        </div>

        {note && (
          <>
            <div style={{ height: '10px' }} />
            <div style={{ fontSize: '9px' }}>Note : {note}</div>
          </>
        )}

        <div style={{ height: '12px' }} />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ padding: '10px', border: '1px solid #000' }}>
            <QRCode
              value={upiQrData}
              size={160}
              quietZone={0}
              bgColor="#ffffff"
              fgColor="#000000"
              qrStyle="squares"
            />
          </div>
        </div>
        <div style={{ height: '8px' }} />
        <div className="pdf-text-bold" style={{ fontSize: '11px', textAlign: 'center' }}>Scan QR to Pay</div>
        <div style={{ height: '10px' }} />
        <hr className="pdf-divider" />
        <div style={{ height: '8px' }} />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ fontSize: '9px' }}>Powered by </div>
          <img src="/wide_logo.png" alt="Powered By" style={{ height: '14px', marginLeft: '4px' }} />
        </div>
      </div>

      <div className="receipt-actions no-print" style={{ gap: '12px', marginTop: '24px' }}>
        <button className="action-button print-btn" onClick={() => window.print()}>
          Print Receipt
        </button>
        <button className="action-button pay-btn" onClick={() => window.location.replace(upiQrData)}>
          Pay Now
        </button>
      </div>
    </div>
  );
}

export default ReceiptScreen;
